import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './formsBrowser.module.scss';
import { Icon } from '../../components/icon/Icon';
import { FormProps, SelectionProps } from './types/FormTypes';

export const Form = React.memo(
    (props: { form: FormProps; selectionProps: SelectionProps }) => {
        const { t } = useTranslation();

        try {
            const {
                form,
                selectionProps: { handleOnFormSelect },
            } = props;

            if (!form) {
                return null;
            } else {
                return (
                    <button
                        type="button"
                        className={styles.formContainer}
                        onClick={() => handleOnFormSelect(form)}
                        aria-label={t('FormsBrowser.SelectForm', 'Select form: {{title}}', { title: form?.Alias__c || form?.Title__c })}
                    >
                        <span className={styles.formIconContainer} aria-hidden="true">
                            <Icon
                                icon={form?.Icon__c}
                                color="blue"
                                size="big"
                            />
                        </span>
                        <span className={styles.formAliasContainer}>
                            {form?.Alias__c}
                        </span>
                    </button>
                );
            }
        } catch {
            return null;
        }
    },
);
